import "./ActiveInactiveSwitch.scss";

type ActiveInactiveSwitchProps = {
  className?: string;
  isActive: boolean;
  isShowLabel?: boolean;
  onToggle: (value: boolean) => void;
};

const ActiveInactiveSwitch: React.FC<ActiveInactiveSwitchProps> = ({
  className,
  isActive,
  isShowLabel = true,
  onToggle,
}) => {
  const handleToggle = () => {
    onToggle(!isActive);
  };

  return (
    <div className={`${className ? className : "switch-container"}`}>
      {isShowLabel && (
        <span className={`label ${isActive ? "active" : "inactive"}`}>
          {isActive ? "Active" : "Inactive"}
        </span>
      )}
      <div
        className={`switch ${isActive ? "on" : "off"}`}
        onClick={handleToggle}
      >
        <div className="toggle" />
      </div>
    </div>
  );
};

export default ActiveInactiveSwitch;
